// Funciones para validar los formularios

const rules = {
    validate_length(value, num) {
        if (value) return value.length <= num || `No puede tener más de ${num} carácteres`
        else return true
    },
    validate_min_length(value, num) {
        if (value) return value.length >= num || `Debe tener al menos ${num} carácteres`
        else return true
    },
    required(value) {
        return !!value || "Este campo es obligatorio"
    },
    validate_email(value) {
        if (value) return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,60}[a-zA-Z0-9])+)+$/.test(value) || "Introduce una dirección de email válida"
        else return true
    },
    validate_integer(value, num) {
        if (value) return value >= num || `Debe ser al menos ${num}`
        else return true
    },
    only_integer(value) {
        if (value) return /^[-+]?\d*$/.test(value) || 'Sólo se permiten números enteros';
        return true
    },
    validate_decimals(value) {
        if (value) return /^\d+(\.\d{1,2})?$/.test(value) || 'Sólo se permiten dos decimales';
        return true
    },
    compare_passwords(password, password_confirmation) {
        if (password && password_confirmation) return !password.localeCompare(password_confirmation) || 'Las contraseñas no coinciden';
        return true
    }
}

export default rules